import {Module} from 'vuex';
import {Api} from 'modules/spravochnik/dt-front-page-generator/src/Api';

interface ConfigStateInterface {
    sliders: Array<any>,
    loaded: boolean,
}

const configModule: Module<ConfigStateInterface, any> = {
    namespaced: true,
    state: {
        sliders: [],
        loaded: false,
    },
    getters: {
        sliders(state: ConfigStateInterface): Array<any> {
            return state.sliders;
        },
    },
    actions: {
        async loadSliders({commit, state}) {
            if (state.loaded) {
                commit('setSliders', state.sliders);
                return Promise.resolve();
            }

            const list = await Api.fetchSliders();
            commit('setSliders', list);
        },
    },
    mutations: {
        setSliders(state: ConfigStateInterface, list: Array<any>) {
            state.sliders = list;
            state.loaded = true;
        }
    },
}

export {configModule, ConfigStateInterface};
